import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { getBots } from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { truncateString } from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import SearchComponent from "../Components/CommanSearch";
import DeleteModal from "../Components/DeleteModal";
import AdminActions from "../Redux/Actions/AdminActions";
import ExportModal from "../Components/ExportModal";

export default function Bots() {
  const botList = useSelector((e) => e.userAuth.botList)
  const ImageUrl = process.env.REACT_APP_IMG_URL
  const Domain_url = process.env.REACT_APP_PROJECT_DOMAIN_URL
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate()

  const totalEntries = botList?.pagination?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentBotId, setCurrentBotId] = useState('');
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false)
  const handleShow = (id) => {
    setCurrentBotId(id)
    setShow(true)
  }

  const generateChatbotScript = (res, ImageUrl) => {
    return `<script
      src="${Domain_url}/widget.js"
      data-header-color="#ff5733" 
      data-bubble-color="#1a1a1a" 
      data-message-color="#f4f4f5" 
      data-theme-color="${res.color}" 
      data-bot-name="${res.name}" 
      data-chatbot-id="${res.chatbotId}" 
      data-chat-id="${res._id}"
      data-welcome-message="${res.welcomeMessage}" 
      data-custom-message-limit="${res.customMessageWhenLimitExceed}" 
      data-icon="${ImageUrl}${res.icon}"
      data-logo="${ImageUrl}${res.logo}"
      data-sponsorUrl="${ImageUrl}${res?.sponsoredImage}"
    ></script>`;
  };

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handlePageChange = (page) => {
    setCurrentPage(page + 1);
    navigate(`/chatbots?page=${page + 1}`)
  };

  const handleCopyToClipboard = (scriptText) => {
    navigator.clipboard.writeText(scriptText)
      .then(() => {
        alert('Script copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy script: ', err);
      });
  };

  const handleChange = async (id) => {
    setCurrentBotId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteUser = () => {
    dispatch(AdminActions.deleteBot({ chatbotId: currentBotId })).then((res) => {
      if (res?.payload?.status == 200) {
        toast.success(res?.payload?.message);
        Inialize()
      } else {
        toast.error(res?.payload?.message);
      }
      handleCloseDeleteModal();
    });
  };

  const Inialize = () => {
    try {
      const params = new URLSearchParams(location.search);
      const page = params.get("page") || currentPage;
      setCurrentPage(page)
      const searchQuery = params.get("search") || "";
      const queryParams = searchQuery ? { name: searchQuery } : { page: page, limit };
      dispatch(startstopLoading(true));
      dispatch(getBots(queryParams)).then((res) => {
        dispatch(startstopLoading(false));
      });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    Inialize()
  }, [location.search, dispatch, currentPage, location.pathname, limit]);
  return (
    <Layout>
      <Container fluid>
        <div className="filters">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>Chatbots</h2>
            </div>
            <div className="user-search">
              <div className="drop-down">
                <div className="select-box">
                  <Form.Select aria-label="Default select example" onChange={(e) => setLimit(e.target.value)}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
              <div className="search-tab">
                <div className="input-search">
                  <SearchComponent heading='Bot' />
                </div>
                <div
                  onClick={() => navigate(`/add-new-chatbot`)}
                  className="export-box"
                >
                  <p>Add New Chatboot</p>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <Table size="sm" className="table-cmn">
                <thead>
                  <tr>
                    <th>Chatboot ID</th>
                    <th>Chatboot Name</th>
                    <th>Embedded URL </th>
                    <th>Export Chat</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {botList?.chatbots?.map((res, index) =>
                    <tr key={index}>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{res.chatbotId}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="user-role">
                          <p>{res.name}</p>
                        </div>
                      </td>
                      <td>
                        {" "}
                        <div
                          className="cont-num"
                          onClick={() => handleCopyToClipboard(generateChatbotScript(res, ImageUrl))}
                          data-toggle="tooltip"
                          data-placement="top"
                          title={generateChatbotScript(res, ImageUrl)}
                        >
                          {truncateString(generateChatbotScript(res, ImageUrl))}
                        </div>
                      </td>

                      <td>
                        <div className="m-0 p-0">
                          <button className="btn btn-primary" onClick={() => handleShow(res.chatbotId)} >Export Chat</button>
                        </div>
                      </td>
                      <td>
                        <div className="active">
                          <p>Active</p>
                        </div>
                      </td>
                      <td>
                        <div className="action">
                          <div
                            onClick={() => handleChange(res.chatbotId)}
                          >
                            <img
                              src={
                                require("../Assets/Images/delete-icon.svg").default
                              }
                            />
                          </div>
                          <div
                            onClick={() => navigate(`/add-new-chatbot?id=${res.chatbotId}`)}
                          >
                            <img
                              src={
                                require("../Assets/Images/view-icon.svg").default
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {botList?.pagination?.total > 1 && (
                <PaginationComponent
                  currentPage={currentPage - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />)}
            </div>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              {" "}
              © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDeleteUser}
        name={"bot"}
      />
      <ExportModal
        show={show} handleClose={handleClose} chatbotId={currentBotId}
      />
    </Layout>
  );
}
